import { FC, SVGProps } from "react";

type Props = SVGProps<SVGSVGElement>;

/**
 * YouTube Shorts logo icon component
 */
export const YouTubeShortsLogo: FC<Props> = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5127 1.48461C16.5877 0.403441 19.1569 1.19106 20.2491 3.24437C21.3411 5.29782 20.5445 7.83862 18.4698 8.92015L16.7627 9.81761C18.2327 9.87133 19.6351 10.6784 20.3692 12.0588C21.4613 14.1124 20.6658 16.6532 18.5889 17.7346L9.49028 22.5149C7.41526 23.5962 4.84612 22.8086 3.75395 20.7551C2.66186 18.7016 3.45838 16.1608 5.53325 15.0793L7.24028 14.1819C5.77036 14.1282 4.3679 13.3211 3.63384 11.9407C2.54181 9.88709 3.33908 7.34626 5.41411 6.26488L14.5127 1.48461ZM9.60161 15.3977L15.1084 12.0139L9.60161 8.61449V15.3977Z"
      fill="currentColor"
    />
  </svg>
);
